import { render, staticRenderFns } from "./DonutPie.vue?vue&type=template&id=281aba7e&scoped=true&"
import script from "./DonutPie.vue?vue&type=script&lang=js&"
export * from "./DonutPie.vue?vue&type=script&lang=js&"
import style0 from "./DonutPie.vue?vue&type=style&index=0&id=281aba7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281aba7e",
  null
  
)

export default component.exports